import React from "react"
import PartnersIcons from "../../../../static/assets/homepage/new_partners.png"
import "../home.css"
import { Link } from "gatsby"

function Slide1() {
  return (
    <div className="hero-container">
      <div>
        <h1 className="hero-title">Next level Design & Technology</h1>

        <h2 className="hero-subtitle">
          Design. Web Development. Mobile development. software maintainance.
          tech consulting
        </h2>
      </div>

      <div
        style={{
          flexGrow: 1,
        }}
      >
        <Link
          to="/services#service-page-inquiry"
          style={{
            textDecoration: "none",
          }}
        >
          <button className="hero-button">GET STARTED</button>
        </Link>
      </div>
      <div className="hero-footer">
        <span>Our Clients / partners...</span>
        <img src={PartnersIcons} alt="Partners" className="partners-image" />
      </div>
    </div>
  )
}

export default Slide1
